import React from 'react';
import { X, Send, Search } from 'lucide-react';
// Note: Styles are expected to be handled by the parent page's CSS (e.g., _AIProjectManager.css)
// or ensuring the classes .modal-overlay, .modal-content, etc. are globally available.

const FindContractorsModal = ({ isOpen, onClose, onPostJob, onBrowsePros, taskName }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="modal-close-btn" onClick={onClose}>
                    <X size={24} />
                </button>
                <h2>Find Professionals</h2>
                <p className="modal-subtitle">
                    How would you like to connect with contractors for <strong>{taskName}</strong>?
                </p>
                
                <div className="modal-options">
                    <div className="modal-option-card" onClick={onPostJob}>
                        <div className="option-card-icon">
                            <Send size={24} />
                        </div>
                        <h3>Post a Job</h3>
                        <p>Broadcast your job details to all matching local contractors and receive quotes.</p>
                    </div>

                    <div className="modal-option-card" onClick={onBrowsePros}>
                        <div className="option-card-icon">
                            <Search size={24} />
                        </div>
                        <h3>Browse Local Pros</h3>
                        <p>View profiles of contractors in your area and invite the ones you like to quote.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FindContractorsModal;
